import { Component, OnInit, Input} from "@angular/core";
import { Router, NavigationStart } from '@angular/router';
//import { GridOptions, ColDef, AllModules, IDateFilterParams } from '@ag-grid-enterprise/all-modules';
import { GridOptions, ColDef,  IDateFilterParams, GridApi } from "ag-grid-community";

import { Observable, EMPTY } from 'rxjs';
import { filter, finalize, map } from "rxjs/operators";

import { dateComparator, dateFilterComparator } from "../../../common/components/data-table/comparators/data-table.comparators";
import { RouterLinkRendererComponent } from "../../../common/components/ag-grid/router-link-renderer.component";

import { LettersService } from "../../../letters/letters.service";

import { Letter, LetterSearchCriteria, LetterStatus, LetterSearchOrderDirection } from "../../../letters/letters.model";
import { GridFormatterService } from "../../../common/services/grid-formatter.service";

@Component({
    selector: "pending-mail-widget",
    templateUrl: "./pending-mail-widget.component.html",
    styleUrls: ["./pending-mail-widget.component.scss"],
    standalone: false
})

export class PendingMailWidgetComponent implements OnInit {
    @Input() widgetTitle: string;


    data: Observable<Letter[]>;
    gridOptions : GridOptions;
	gridApi?: GridApi;
    constructor (
        public readonly lettersService: LettersService,
        private formatterService: GridFormatterService,
        private router: Router
	) { }

    ngOnInit() {
        const criteria = {
            inStatuses: [ LetterStatus.Pending ],
            orderByPropertyName:"CreatedDate",
            orderDirection: LetterSearchOrderDirection.Descending,
        } as LetterSearchCriteria;

        this.gridOptions = {
            columnDefs: this.createColumnDefinitions(),
            defaultColDef: { filter: true, sortable: true } as ColDef,
            enableBrowserTooltips: false,
            tooltipTrigger: 'focus',
			onGridReady: (params) => {
				this.gridApi = params.api;
                this.gridApi.sizeColumnsToFit();
            },
            suppressHorizontalScroll: true,
            pagination: true,
            paginationAutoPageSize: true,
            headerHeight: 50
        } as GridOptions;

        this.data = this.lettersService.find(criteria);

        this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((routerEvent: NavigationStart) => {
            this.data = EMPTY;
        });
    }

    blankFieldFormatter(component: any, field: string) {
        return (obj: any) => { return (obj.data[field] && obj.data[field].length > 0) ? obj.data[field] : "Unknown" };
    }

    public createColumnDefinitions() {
        const colDefs = [
            {
                headerClass: "wrapped",
                comparator: dateComparator,
                headerName: "Date Created",
                headerTooltip: "Date Created",
                field: "createdDate",
                tooltipValueGetter: this.formatterService.formatDate("createdDate"),
                valueGetter: this.formatterService.formatDate("createdDate"),
                filter: "agDateColumnFilter",
                filterParams: { browserDatePicker: true, comparator: dateFilterComparator, includeTime: false, buttons: ['reset'] } as IDateFilterParams,
                sort: "desc",
                sortingOrder: ["asc", null, "desc"],
                maxWidth: 125
            },
            {
                headerClass: "wrapped",
                headerName: "Organization",
                headerTooltip: "Organization",
                field: "organizationName",
                tooltipField: 'organizationName',
                filter: "agTextColumnFilter",
                cellRenderer: RouterLinkRendererComponent,
                cellRendererParams: {
                    idField: "id",
                    textField: "organizationName",
                    url: "/letters"
                }
            },
            {
                headerClass: "wrapped",
                headerName: "Description",
                headerTooltip: "Description",
                field: "title",
                tooltipField: 'title',
                valueGetter: this.blankFieldFormatter(this, "title"),
                filter: "agTextColumnFilter"
            },
            {
                headerClass: "wrapped",
                headerName: "Mailing Type",
                headerTooltip: "Mailing Type",
                field: "mailType",
                tooltipField: 'mailType',
                filter: 'agSetColumnFilter',
                maxWidth: 125
            }
        ] as ColDef[];
        this.formatterService.applyFilterKeyboardHintTooltips(colDefs);
        return colDefs;
    }
}
